import * as HoverCard from "@radix-ui/react-hover-card"

type TooltipProps = {
  /**
   * The contents of the tooltip
   */
  content: React.ReactNode
  /**
   * The tooltip trigger and anchor
   */
  children: React.ReactNode
  asChild?: boolean
  className?: string
  disabled?: boolean
}

/**
 * @description A simple tooltip component that shows content on hover.
 */
export const Tooltip = ({
  children,
  content,
  asChild,
  className,
  disabled,
}: TooltipProps) => {
  return (
    <HoverCard.Root openDelay={50} closeDelay={100}>
      <HoverCard.Trigger className={className} asChild={asChild}>
        {children}
      </HoverCard.Trigger>
      {!disabled && (
        <HoverCard.Portal>
          <HoverCard.Content className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 pointer-events-none z-[9999] cursor-default select-none transition-opacity duration-200 ease-out">
            <HoverCard.Arrow height={8} width={8} className="invisible" />
            <div className="bg-inverse-surface text-inverse-on-surface select-none rounded px-2 py-1 text-sm">
              {content}
            </div>
          </HoverCard.Content>
        </HoverCard.Portal>
      )}
    </HoverCard.Root>
  )
}
